import { CardImageSkeleton } from "Pages/AllCards/allCardsSkeleton";
import { useState } from "react";

export const CardImage = ({ src, alt, style }) => {
  const [isImageLoading, setIsImageLoading] = useState(true);
  return (
    <>
      {isImageLoading && <CardImageSkeleton />}
      <img
        src={src}
        alt={alt}
        onLoad={() => {
          setIsImageLoading(false);
        }}
        style={{ display: isImageLoading ? "none" : "block", ...style }}
      />
    </>
  );
};
